<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  current: number
  total: number
}>()

const pct = computed(() => Math.min(100, Math.max(0, (props.current / props.total) * 100)))
</script>

<template>
  <div
    class="stepper"
    role="progressbar"
    :aria-valuenow="current"
    :aria-valuemin="0"
    :aria-valuemax="total"
    :aria-label="`Étape ${current} sur ${total}`"
  >
    <div class="stepper__track">
      <div class="stepper__fill" :style="{ width: `${pct}%` }"></div>
    </div>
    <p class="stepper__label">
      <span class="stepper__current">{{ current }}</span>
      <span class="stepper__sep">/</span>
      <span class="stepper__total">{{ total }}</span>
    </p>
  </div>
</template>

<style scoped>
.stepper {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  flex: 1;
  min-width: 0;
}
.stepper__track {
  flex: 1;
  height: 6px;
  background: var(--bg-soft);
  border-radius: var(--radius-pill);
  overflow: hidden;
}
.stepper__fill {
  height: 100%;
  background: var(--primary);
  border-radius: inherit;
  transition: width var(--dur-base) var(--ease-spring);
}
.stepper__label {
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
  letter-spacing: 0.04em;
}
.stepper__current { color: var(--primary); }
.stepper__sep { margin-inline: 0.15em; opacity: 0.6; }
</style>
